import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { loadi18nConfig } from './i18nConfig';

const reactI18n = i18n.createInstance();

// --- Initialize i18next with config (with guard against double initialization) ---
(async () => {
  try {
    const config = await loadi18nConfig();
    const { initialLanguage = 'en', i18nPaths = {} } = config || {};

    // --- Initialize i18next ---
    await reactI18n
      .use(initReactI18next)
      .use(HttpBackend)
      .init({
        lng: initialLanguage,
        fallbackLng: 'en',
        backend: {
          loadPath: (lng, ns) => {
            const path = i18nPaths[lng] || i18nPaths['en'] || '';
            // If no valid path, return a path that will fail to load
            return path || '/invalid-path-force-fallback';
          },
        },
      });
    console.log('i18next react initialized successfully');
  } catch (error) {
    console.error('Failed to initialize i18next react:', error);
  }
})();

export default reactI18n;
